/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { Method,prepare,QueryStringArrayFormat,RequestBodyType,ResponseBodyType } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from './request'
// @ts-ignore
import makeRequestHook from './makeRequestHook'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_0 = 'http://yapi.yishou.com/mock/187' as any
const devUrl_0_0_0_0 = '' as any
const prodUrl_0_0_0_0 = '' as any
const dataKey_0_0_0_0 = 'data' as any

export interface UserRequest {}

export interface UserResponse {
  /**
   * 最后登录
   */
  lastLoginTime?: string
  /**
   * 头像
   */
  logo?: string
  /**
   * 角色id
   */
  roleId?: number
  /**
   * 角色名
   */
  roleName?: string
  /**
   * 供应商列表
   */
  suppliers?: {
    /**
     * 商品是否免除审核{0:否,1:是}
     */
    goodsExemptExamine?: number
    /**
     * 入驻状态：0:未申请,1:待审核,2:已审核,3:已驳回
     */
    newAuditStatus?: number
    /**
     * 店铺Id
     */
    shopId?: number
    /**
     * 店铺名称
     */
    shopName?: string
    /**
     * 供应商Id
     */
    supplierId?: number
    /**
     * 所属市场
     */
    supplierMark?: string
    /**
     * 供应商名称
     */
    supplierName?: string
  }[]
  /**
   * 用户Id
   */
  userId?: number
  /**
   * 用户名称
   */
  userName?: string
}

type UserRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/manage/user',
    'data',
    string,
    string,
    true
  >
>

const userRequestConfig: UserRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/user',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {
    type: 'object',
    properties: {
      lastLoginTime: {type: 'string', format: 'date-time', description: '最后登录'},
      logo: {type: 'string', description: '头像'},
      roleId: {type: 'integer', format: 'int32', description: '角色id'},
      roleName: {type: 'string', description: '角色名'},
      suppliers: {
        type: 'array',
        description: '供应商列表',
        items: {
          type: 'object',
          properties: {
            goodsExemptExamine: {
              type: 'integer',
              description: '商品是否免除审核{0:否,1:是}',
              format: 'int32',
            },
            newAuditStatus: {
              type: 'integer',
              description: '入驻状态：0:未申请,1:待审核,2:已审核,3:已驳回',
              format: 'int32',
            },
            shopId: {type: 'integer', format: 'int32', description: '店铺Id'},
            shopName: {type: 'string', description: '店铺名称'},
            supplierId: {type: 'integer', format: 'int32', description: '供应商Id'},
            supplierMark: {type: 'string', description: '所属市场'},
            supplierName: {type: 'string', description: '供应商名称'},
          },
          title: 'SupplierDto',
          description: '供应商信息',
          required: [],
        },
      },
      userId: {type: 'integer', format: 'int64', description: '用户Id'},
      userName: {type: 'string', description: '用户名称'},
    },
    title: 'SupplierUserDto',
    description: '供应商账户信息',
  },
  requestFunctionName: 'user',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

export const user = /*#__PURE__*/ (requestData?: UserRequest, ...args: UserRequestRestArgs) => {
  return request<UserResponse>(prepare(userRequestConfig, requestData), ...args)
}

user.requestConfig = userRequestConfig

export const useUser = /*#__PURE__*/ makeRequestHook<
  UserRequest,
  UserRequestConfig,
  ReturnType<typeof user>
>(user)

export interface LogoutRequest {}

export interface LogoutResponse {}

type LogoutRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/manage/user/logout',
    'data',
    string,
    string,
    true
  >
>

const logoutRequestConfig: LogoutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/user/logout',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {type: 'object'},
  requestFunctionName: 'logout',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

export const logout = /*#__PURE__*/ (requestData?: LogoutRequest, ...args: UserRequestRestArgs) => {
  return request<LogoutResponse>(prepare(logoutRequestConfig, requestData), ...args)
}

logout.requestConfig = logoutRequestConfig

export const useLogout = /*#__PURE__*/ makeRequestHook<
  LogoutRequest,
  LogoutRequestConfig,
  ReturnType<typeof logout>
>(logout)

/* prettier-ignore-end */
